/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:06 GMT
 *
 */


const theme = {
  appearances: {
    checked: {
      description: 'Corresponds to a selected state for a checkbox or radio',
      type: 'state',
      values: [ true ]
    },
    error: { type: 'state', values: [ true ] },
    focus: {
      description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    hover: {
      description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    inactive: {
      description: 'Prevents an interactive component from being interacted with and applies accessibility attributes to indicate to the user that this component cannot be used.',
      type: 'state',
      values: [ true ]
    },
    pressed: {
      description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
      type: 'state',
      values: [ true, false ]
    },
    viewport: {
      description: 'The size label for the current screen viewport based on the current screen width',
      type: 'state',
      values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
    }
  },
  rules: [
    {
      if: { viewport: [ 'lg', 'xl' ] },
      tokens: {
        fontSize: 24,
        lineHeight: 1.3,
        paddingBottom: 24,
        paddingLeft: 16,
        paddingRight: 24,
        paddingTop: 16
      }
    },
    {
      if: { hover: true },
      tokens: {
        backgroundColor: 'rgba(0, 0, 0, 0.05)',
        borderColor: '#c9c8c8',
        checkboxOuterBorderColor: 'rgba(0, 0, 0, 0)',
        checkboxOuterBorderGap: 0,
        checkboxOuterBorderWidth: 0,
        outerBorderColor: 'rgba(0, 0, 0, 0)',
        outerBorderGap: 0,
        outerBorderWidth: 0
      }
    },
    {
      if: { checked: true },
      tokens: {
        borderColor: '#c9c8c8',
        checkboxCheckedBackgroundColor: '#7a3dfc',
        checkboxInputBorderColor: '#000000',
        checkboxInputBorderWidth: 2
      }
    },
    {
      if: { focus: true },
      tokens: {
        borderColor: '#666666',
        checkboxInputBorderColor: '#000000',
        checkboxOuterBorderColor: '#000000',
        checkboxOuterBorderGap: 2,
        checkboxOuterBorderWidth: 1,
        outerBorderColor: '#000000',
        outerBorderGap: 2,
        outerBorderWidth: 2
      }
    },
    {
      description: 'Pressed state matches hover state plus light grey background',
      if: { pressed: true },
      tokens: {
        backgroundColor: 'rgba(0, 0, 0, 0.1)',
        borderColor: '#c9c8c8',
        checkboxOuterBorderColor: 'rgba(0, 0, 0, 0)',
        checkboxOuterBorderGap: 0,
        checkboxOuterBorderWidth: 0,
        outerBorderColor: 'rgba(0, 0, 0, 0)',
        outerBorderGap: 0,
        outerBorderWidth: 0
      }
    },
    {
      if: { inactive: true },
      tokens: {
        backgroundColor: '#efefef',
        borderColor: 'transparent',
        checkboxCheckedBackgroundColor: '#c9c8c8',
        checkboxInputBackgroundColor: '#c9c8c8',
        checkboxInputBorderColor: '#c9c8c8',
        checkboxInputSize: 16,
        checkboxOuterBorderColor: '#c9c8c8',
        checkboxOuterBorderGap: 2,
        checkboxOuterBorderWidth: 1,
        color: '#666666'
      }
    },
    {
      if: { error: true },
      tokens: {
        borderColor: '#df3d0c',
        checkboxInputBorderColor: '#df3d0c',
        color: '#df3d0c'
      }
    }
  ],
  tokens: {
    backgroundColor: '#ffffff',
    borderColor: '#c9c8c8',
    borderRadius: 4,
    borderWidth: 1,
    checkboxCheckedBackgroundColor: '#000000',
    checkboxCheckedSize: 16,
    checkboxInputBackgroundColor: '#ffffff',
    checkboxInputBorderColor: '#000000',
    checkboxInputBorderWidth: 2,
    checkboxInputOutlineColor: 'rgba(0, 0, 0, 0)',
    checkboxInputOutlineWidth: 0,
    checkboxInputSize: 24,
    checkboxOuterBorderColor: 'transparent',
    checkboxOuterBorderGap: 0,
    checkboxOuterBorderWidth: 0,
    checkboxSpace: 2,
    color: '#000000',
    contentAlignItems: 'stretch',
    contentFlexGrow: 0,
    contentFlexShrink: 1,
    contentJustifyContent: 'flex-start',
    contentSpace: 2,
    flex: 1,
    fontName: 'StagSans',
    fontSize: 20,
    fontWeight: '700',
    letterSpacing: 0,
    lineHeight: 1.4,
    minWidth: 288,
    outerBorderColor: 'transparent',
    outerBorderGap: 0,
    outerBorderWidth: 0,
    paddingBottom: 16,
    paddingLeft: 8,
    paddingRight: 16,
    paddingTop: 12,
    shadow: null,
    textTransform: 'none'
  }
}
export default theme
